var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThemeProvider',[_c('mp-box',{attrs:{"overflow":"hidden"}},[_c('MpReset'),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }